export default "__VITE_ASSET__CaYEZA1m__"